/**
 * R.E.REPO（リレポ・不動産調査の依頼）の行き先（パスとラベル）。サイドバーとマイページが参照する正本。
 * アイコンは各画面の部品が持つ（このファイルは React に依存させない）。
 */

/** 不動産調査の依頼画面。 */
export const REREPO_REQUEST_PATH = "/real-estate-research-request";

export const REREPO_LABELS = {
  /** サービス名。aria-label と Tooltip に使う。 */
  service: "R.E.REPO",
  request: "不動産調査を依頼する",
  /** サイドバーのロゴに付けるツールチップ。 */
  sideMenuTooltip: "不動産の調査、売買契約書の作成、重説チェックを依頼できます",
} as const;
